// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio {
    width: 100%;
    display:block;
}

.radioButton {
    margin-right: 8px;
    display :inline-flex;
}

.radio radio-button {
    text-decoration: inherit !important;
    font-weight: inherit !important;
    color:inherit!important;
}


/*::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-inner-circle {
    background-color: #C4DBEE !important;
}

::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
    border-color: #C4DBEE !important;
}

::ng-deep .mat-ripple-element {
    background-color: #C4DBEE !important;
}

::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {
    background-color: #C4DBEE !important;
}*/`, "",{"version":3,"sources":["webpack://./src/app/components/controls/radiobutton/radiobutton.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,uBAAuB;AAC3B;;;AAGA;;;;;;;;;;;;;;EAcE","sourcesContent":[".radio {\n    width: 100%;\n    display:block;\n}\n\n.radioButton {\n    margin-right: 8px;\n    display :inline-flex;\n}\n\n.radio radio-button {\n    text-decoration: inherit !important;\n    font-weight: inherit !important;\n    color:inherit!important;\n}\n\n\n/*::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-inner-circle {\n    background-color: #C4DBEE !important;\n}\n\n::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {\n    border-color: #C4DBEE !important;\n}\n\n::ng-deep .mat-ripple-element {\n    background-color: #C4DBEE !important;\n}\n\n::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {\n    background-color: #C4DBEE !important;\n}*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
